<template>
  <div :class="isFull == 1 ? 'host_activity_log top_information1' : ' host_activity_log'">
    <!-- Header Navigation -->
    <van-nav-bar
      :title="$t('column.Reward_Claim_History')"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
    />

    <!-- Date Search Selection -->
    <div class="search-bar">
      <div class="date-selector" @click="showDatePicker = true">
        <span class="date-text">{{ currentDateStr || $t('column.all') }}</span>
        <van-icon name="arrow-down" class="date-icon" />
      </div>
      <div class="reset-btn" v-if="currentDateStr" @click="resetDate">
        {{ $t('btn.cancel') }}
      </div>
    </div>

    <!-- Date Picker Popup -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="$t('column.date')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirmDate"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <!-- Data List -->
    <div class="list-container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          @load="onLoad"
        >
          <div class="log-card" v-for="(item, index) in list" :key="index">
            <div class="card-top">
              <div class="time-wrapper">
                <van-icon name="clock-o" class="icon-clock" />
                <span class="time-text">{{ formatTime(item.create_time) }}</span>
              </div>
              <div class="reward-wrapper">
                <span class="reward-plus">+</span>
                <span class="reward-amount">{{ item.daily_reward }} <img src="../assets/img/coin9.png"/> </span>
              </div>
            </div>
            
            <van-divider dashed :style="{ margin: '8px 0', borderColor: '#f0f0f0' }"></van-divider>
            
            <div class="card-bottom">
              <div class="status-tag tag-period">
                <van-icon name="bar-chart-o" class="tag-icon" />
                <span>{{ $t('column.collection_period') }}:  {{ item.host_i }}h</span>
              </div>
              <div :class="['status-tag', item.new_host == 1 ? 'tag-protected' : 'tag-unprotected']">
                <van-icon name="shield-o" class="tag-icon" />
                <span>{{ item.new_host == 1 ? $t('column.new_host') : $t('column.general_host') }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import axios from "axios";
export default {
  name: 'host_activity_log',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      showDatePicker: false,
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDateStr: '', // Empty means all
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
   created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    formatTime(timestamp) {
      if (!timestamp) return '-';
      return dayjs(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    onConfirmDate(value) {
      this.currentDateStr = dayjs(value).format('YYYY-MM-DD');
      this.showDatePicker = false;
      this.onRefresh();
    },
    resetDate() {
      this.currentDateStr = '';
      this.currentDate = new Date();
      this.onRefresh();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.onLoad();
    },
    get_list(){
        this.loading = true
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=host_activity&act=host_activity_log",{ 
            params:{
                token: token,
                page:this.page,
                date: this.currentDateStr
            }
        }).then(res =>{
            console.log(res)
            // 加载状态结束
           this.loading = false;
            if (this.page === 1) {
                this.list = []
            }
            for (let j = 0; j < res.data.data.list.length; j++) {
                this.list.push(res.data.data.list[j])
            }
            //如果列表数据条数< 0，不再触发滚动加载
            if (res.data.data.list.length <= 0) {
                this.finished = true
            }
            this.page ++
        })
    },
    onLoad() {
        if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
        }
        this.get_list()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/host_activity_log.vue